module.exports = __webpack_public_path__ + "img/ar-lqtajwid-1.a0828510.webp";